<ion-menu contentId="main-content" mode="md">
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <div class="toolbar d-flex ion-justify-content-center">
        <ion-img src="small-logo-blue.svg" class="logo"></ion-img>
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-menu-toggle auto-hide="false">
        <ion-item [routerLink]="'home'">
          <ion-icon color="primary" slot="start" name="home-outline"></ion-icon>
          <ion-label>{{ 'MENU.HOME' | translate }}</ion-label>
        </ion-item>

        @if(authService.isUserProvider()) {
        <ion-item [routerLink]="'print-office'">
          <ion-icon color="primary" slot="start" name="print-outline"></ion-icon>
          <ion-label>{{ 'MENU.PROVIDER' | translate }}</ion-label>
        </ion-item>
        }

        <ion-item [routerLink]="'orders'">
          <ion-icon color="primary" slot="start" name="receipt-outline"></ion-icon>
          <ion-label>{{ 'MENU.MY_ORDERS' | translate }}</ion-label>
        </ion-item>

        <ion-item [routerLink]="'profile'">
          <ion-icon color="primary" slot="start" name="person-outline"></ion-icon>
          <ion-label>{{ 'MENU.PROFILE' | translate }}</ion-label>
        </ion-item>

        <ion-item button (click)="openChat()" class="chat-item">
          <ion-icon color="primary" slot="start" name="chatbubbles-outline"></ion-icon>
          <ion-label>{{ 'MENU.HELP' | translate }}</ion-label>
        </ion-item>
      </ion-menu-toggle>
    </ion-list>
  </ion-content>
</ion-menu>

<ion-router-outlet id="main-content"></ion-router-outlet>
